import React from 'react';
import {
  makeStyles,
} from '@material-ui/core';
import cx from 'classnames';
import Select from '../../../FormikFields/ComplexSelect/Select';
import { useParams } from 'react-router';
import useFetchList from '../../../../hooks/useFetchList';
import { useSelector } from 'react-redux';

const useStyles = makeStyles(() => ({}));

const ICDSelector = ({
                       cpt,
                       backendErrors,
                       updateClaimCPTInfo,
                       disabled,
                     }) => {
  const classes = useStyles();
  const { en: { btn, forms } } = useSelector((state) => state.i18n);
  const { accountUuid } = useParams();

  const {
    items,
    totalCount,
    loading: dataLoading,
    onLoadMoreRows,
    onFilter,
    clearFilter,
  } = useFetchList({
    baseEndpoint: `/accounts/${accountUuid}/diagnosis-codes`,
    baseParams: {
      fields: [''].join(),
    },
    baseFilter: cpt.icd ? [{ id: 'code', value: cpt.icd }] : [],
    preferBaseFilter: true,
    canLoad: true,
  });

  const updateClaimCode = (id, key, value) => {
    updateClaimCPTInfo(id, key, value);
  };

   return (
    <Select
      filterValue={cpt.icd}
      required={true}
      hasSearch={true}
      disabled={disabled}
      dataLoading={dataLoading}
      dataKey='icd'
      onLoadMoreRows={() =>
        onLoadMoreRows((items || []).length)
      }
      allowImpreciseMatch
      searchLabel={btn.searchByICDCode}
      totalCount={totalCount || 0}
      columnData={{
        isFilterable: false,
        options: (items || []).map((icd) => {
          return {
            label: icd.code + ' ' + icd.description,
            value: icd.code,
          };
        }),
      }}
      onFilter={(value) => {
        onFilter((filter) => {
          let isAlreadyExist = !!filter.find(item => item.id === 'code');
          if (isAlreadyExist) {
            return filter.map(item => item.id === 'code' ? { id: 'code', value: value } : item);
          } else {
            return [...filter, { id: 'code', value: value }];
          }
        });
      }}
      clearFilter={clearFilter}
      onChange={(dataKey, value) =>
        updateClaimCode(cpt.id, dataKey, value)
      }
      label={forms.icd}
      labelWidth={78}
      updateValue={(dataKey, value) =>
        updateClaimCode(cpt.id, dataKey, value)
      }
      error={backendErrors}
      className={cx(classes.margin0, classes.fullWidth)}
    />
  );
};

export default ICDSelector;
